import {LocalDate} from '@js-joda/core';

/** Раскладка навигации: не выбирает даты и не вводит ограничений от текущего дня. */
export class DatepickerNavigation {
  public static yearPage(year: number, anchorYear: number, min: LocalDate | null, max: LocalDate | null): number {
    // Без границ пять лет до опорного и шесть после; начало блока не сдвигается от каждой стрелки.
    const origin = max ? max.year() - 11 : min ? min.year() : anchorYear - 5;
    const bounded = Math.min(max?.year() ?? year, Math.max(min?.year() ?? year, year));
    return origin + Math.floor((bounded - origin) / 12) * 12;
  }

  public static firstMonth(
    month: LocalDate,
    pane: number,
    count: number,
    min: LocalDate | null,
    max: LocalDate | null,
  ): LocalDate {
    let first = month.withDayOfMonth(1).minusMonths(pane);
    if (max && first.plusMonths(count - 1).isAfter(max.withDayOfMonth(1))) {
      first = max.withDayOfMonth(1).minusMonths(count - 1);
    }
    // В коротком допустимом интервале соседний месяц может быть полностью заблокирован.
    if (min && first.isBefore(min.withDayOfMonth(1))) {
      first = min.withDayOfMonth(1);
    }
    return first;
  }

  public static intersects(start: LocalDate, end: LocalDate, min: LocalDate | null, max: LocalDate | null): boolean {
    return (!min || !max || !min.isAfter(max)) && (!min || !end.isBefore(min)) && (!max || !start.isAfter(max));
  }
}
